var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.49 10.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#36b22e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.12.63c3.02,2.76,6.05,5.53,9.07,8.29.43.39.86.79,1.29,1.18.36.33.89-.2.53-.53C7.99,6.81,4.96,4.04,1.94,1.28,1.51.89,1.08.49.65.1.29-.22-.24.31.12.63H.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.84.1c-3.02,2.76-6.05,5.53-9.07,8.29-.43.39-.86.79-1.29,1.18-.36.33.17.86.53.53,3.02-2.76,6.05-5.53,9.07-8.29.43-.39.86-.79,1.29-1.18.36-.33-.17-.86-.53-.53h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a72ed8149ecdd2ac6fc2ee90d01dda5d.svg";
export { ForwardRef as ReactComponent };